import { forwardRef } from "react";
import type { InputNumberProps } from "./interface";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";

export const InputNumber = forwardRef<HTMLInputElement, InputNumberProps>(
  (
    {
      label,
      fullSize,
      step = 1,
      min,
      max,
      onChange,
      onIncrement,
      onDecrement,
      ...props
    },
    ref
  ) => {
    const handleIncrement = (e?: React.MouseEvent) => {
      e?.preventDefault();
      e?.stopPropagation();
      
      // Prevenir mudança de foco que pode causar scroll
      if (e?.target && 'blur' in e.target && typeof e.target.blur === 'function') {
        (e.target as HTMLElement).blur();
      }
      
      const currentValue = parseFloat(props.value?.toString() || "0");
      const newValue = currentValue + parseFloat(step.toString());

      if (max !== undefined && newValue > parseFloat(max.toString())) return;

      if (onIncrement) {
        onIncrement(newValue);
        return;
      }

      const event = {
        target: { value: newValue.toString() },
      } as React.ChangeEvent<HTMLInputElement>;

      onChange?.(event);
    };

    const handleDecrement = (e?: React.MouseEvent) => {
      e?.preventDefault();
      e?.stopPropagation();
      
      // Prevenir mudança de foco que pode causar scroll
      if (e?.target && 'blur' in e.target && typeof e.target.blur === 'function') {
        (e.target as HTMLElement).blur();
      }
      
      const currentValue = parseFloat(props.value?.toString() || "0");
      const newValue = currentValue - parseFloat(step.toString());

      if (min !== undefined && newValue < parseFloat(min.toString())) return;

      if (onDecrement) {
        onDecrement(newValue);
        return;
      }

      const event = {
        target: { value: newValue.toString() },
      } as React.ChangeEvent<HTMLInputElement>;

      onChange?.(event);
    };

    return (
      <div className={`flex flex-col gap-2 ${fullSize ? "w-full" : "w-[45%]"}`}>
        {label && <label className="font-semibold text-sm">{label}</label>}
        <div className="relative">
          <input
            ref={ref}
            type="number"
            step={step}
            min={min}
            max={max}
            onChange={onChange}
            {...props}
            className={`border border-[#D8DCDE] text-sm py-3 px-4 pr-10 rounded w-full [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield] ${
              props.className || ""
            } ${
              props.value !== undefined &&
              props.value !== "" &&
              props.value !== null
                ? "text-black"
                : "text-[#C2C8CC]"
            }`}
          />
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex flex-col -space-y-1">
            <FaAngleUp
              width={11}
              height={6}
              className="cursor-pointer text-[#555555] hover:text-black transition-colors"
              onClick={handleIncrement}
              onMouseDown={(e) => {
                e.preventDefault();
                // Prevenir que o mouse down cause foco
                e.stopPropagation();
              }}
              tabIndex={-1} // Remover da ordem de tab
              style={{ userSelect: 'none' }} // Prevenir seleção
            />
            <FaAngleDown
              width={11}
              height={6}
              className="cursor-pointer text-[#555555] hover:text-black transition-colors"
              onClick={handleDecrement}
              onMouseDown={(e) => {
                e.preventDefault();
                // Prevenir que o mouse down cause foco
                e.stopPropagation();
              }}
              tabIndex={-1} // Remover da ordem de tab
              style={{ userSelect: 'none' }} // Prevenir seleção
            />
          </div>
        </div>
      </div>
    );
  }
);
